import { DEPLOYMENT_TYPES } from "./constants";
import { mapPrefillResources } from "./documents";

const DEPLOYMENT_TYPE_VALUES = DEPLOYMENT_TYPES.map((item) => item.value);

export const mapDeploymentType = (value) => {
  if (!value) return "";
  const normalized = String(value).trim().toUpperCase().replace(/\s+/g, "-");
  if (DEPLOYMENT_TYPE_VALUES.includes(normalized)) {
    return normalized;
  }
  if (normalized.includes("CLOUD")) return "CLOUD";
  if (normalized.includes("ON-PREM") || normalized.includes("ONPREM")) {
    return "ON-PERMIS";
  }
  return value ? "OTHER" : "";
};

export const mapCountryOptions = (locations) =>
  (Array.isArray(locations) ? locations : []).map((location) => ({
    label: location.name || location.title || location.label,
    value: location.id ?? location.value,
  }));

export const toIdList = (options) =>
  (Array.isArray(options) ? options : [])
    .map((option) => String(option?.value ?? option))
    .filter((value) => Number(value) > 0);

export const mapAnalyzePrefill = (analyzePrefill = {}, wizard = {}) => ({
  ...wizard,
  service: analyzePrefill.service || wizard.softwareName || "",
  url: analyzePrefill.url || wizard.url || "",
  provider: analyzePrefill.provider || null,
  version: analyzePrefill.version || "",
  type: mapDeploymentType(analyzePrefill.type),
  operatingSystem: analyzePrefill.operating_system || "",
  notice: analyzePrefill.notice || "",
  modules: Array.isArray(analyzePrefill.modules) ? analyzePrefill.modules : [],
  resources: mapPrefillResources(analyzePrefill.resources),
  hostingLocations: mapCountryOptions(analyzePrefill.hosting_locations),
  noneEUHostingLocations: mapCountryOptions(
    analyzePrefill.none_eu_hosting_locations
  ),
  hostingEvidence: Array.isArray(analyzePrefill.hosting_evidence)
    ? analyzePrefill.hosting_evidence
    : [],
  aiSystemDetection: analyzePrefill.ai_system_info || null,
  isOwnDevelopment: !!wizard.isOwnDevelopment,
  developmentUsageScope: wizard.usage || "",
});
